<template>
  <v-stepper
    v-model="stepper"
    class="elevation-0 background fill-height">
    <v-card
      tile
      light
      class="full-width"
      color="bars">
      <v-container
        class="pa-0 d-flex justify-center">
        <StepperHeader 
          :stepper="stepper" />        
      </v-container>
    </v-card>
    <v-container
      class="d-flex flex-row"
      style="height: 100%; width: 800px">
      <div
        class="pt-6 ml-n9">
        <v-btn
          @click="stepper == 1 ? $router.go(-1) : stepper -= 1"
          icon>
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </div>
      <v-stepper-items
        class="background fill-height fill-width">
        <v-stepper-content 
          class="pa-0 background fill-height" step="1">
          <Type 
            v-if="stepper == 1"
            @continue="createDraft" 
            :fetchedContract="contract" /> 
        </v-stepper-content>

        <v-stepper-content 
          class="pa-0 background fill-height" step="2">
          <Plan 
            v-if="stepper == 2"
            ref="description"
            @continue="fillData" 
            :fetchedContract="contract" /> 
        </v-stepper-content>

        <v-stepper-content 
          class="pa-0 background fill-height" step="3">
          <taxes
            v-if="stepper == 3"
            :contract="contract"
            @continue="fillData" 
            ></taxes>
        </v-stepper-content>

        <v-stepper-content 
          class="pa-0 background fill-height" step="4">
          <Documentation 
            v-if="stepper == 4"
            @updateImages="updateImages"
            @continue="fillData" 
            :fetchedContract="contract" /> 
        </v-stepper-content>

        <v-stepper-content 
          class="pa-0 background fill-height" step="5">
          <Confirmation 
            v-if="stepper == 5"
            @continue="publish"
            :fetchedContract="contract" /> 
        </v-stepper-content>
      </v-stepper-items>
    </v-container>
  </v-stepper>
</template>

<script>
import StepperHeader from '@/components/contracts/create/StepperHeader'
import Type from '@/components/contracts/create/stepper/Type'
import Plan from '@/components/contracts/create/stepper/Plan'
import Taxes from '@/components/contracts/create/stepper/Taxes'
import Documentation from '@/components/contracts/create/stepper/Documentation'
import Confirmation from '@/components/contracts/create/stepper/Confirmation'

export default {
  data () {
    return {
      stepper: 1,
      contract: {
        id: null
      }
    }
  },

  props: {
    fetchedContract: {
      type: Object,
      required: false,
      default: () => {
        return {
          id: null
        }
      }
    }
  },

  components: {
    StepperHeader,
    Type,
    Plan,
    Documentation,
    Confirmation,
    Taxes
  },

  created () {
    this.contract = this.fetchedContract
  },

  methods: {
    createDraft (contract) {
      this.stepper  = 2
      this.contract = contract
    },

    fillData (contract) {
      this.stepper = parseInt(this.stepper) + 1
      this.contract = contract
    },

    updateImages (images) {
      this.contract.images = images
    },

    publish () {
      this.$router.push({ name: 'Contracts', params: { success: true } })
    }
  }
}
</script>
